import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Linkedin, Twitter } from "lucide-react";
import { company, loanPrograms } from "../mock";

export default function Footer() {
  const quickLinks = [
    { label: "Commercial Loans", to: "/loan-programs/commercial-real-estate" },
    { label: "Apartment Loans", to: "/loan-programs/apartment-loans" },
    { label: "Bridge Loans", to: "/loan-programs/bridge-loans" },
    { label: "Hard Money Loans", to: "/loan-programs/hard-money-loans" },
    { label: "Working Capital", to: "/loan-programs/working-capital-loans" },
  ];

  return (
    <footer className="bg-[#0b1f3a] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="mb-5">
              <img src="/logo-white.png" alt="LTR Capital Partners" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Commercial real estate finance for investment properties and funding for small,
              medium and large businesses — with loan amounts up to {company.maxLoan}.
            </p>
            <div className="flex gap-3 mt-6">
              {[
                { Icon: Facebook, label: "Facebook" },
                { Icon: Twitter, label: "Twitter" },
                { Icon: Linkedin, label: "LinkedIn" },
              ].map(({ Icon, label }) => (
                <a key={label} href="#" aria-label={label} className="h-9 w-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#c6a15b] hover:text-[#0b1f3a] transition">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Loan programs */}
          <div>
            <h4 className="font-display font-bold text-white mb-5">Loan Programs</h4>
            <ul className="space-y-3 text-sm">
              {loanPrograms.slice(0, 6).map((p) => (
                <li key={p.slug}>
                  <Link to={`/loan-programs/${p.slug}`} className="hover:text-[#c6a15b] transition">
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display font-bold text-white mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {quickLinks.map((q) => (
                <li key={q.label}>
                  <Link to={q.to} className="hover:text-[#c6a15b] transition">{q.label}</Link>
                </li>
              ))}
              <li><Link to="/personal-loans" className="hover:text-[#c6a15b] transition">Personal Loans</Link></li>
              <li><Link to="/tools" className="hover:text-[#c6a15b] transition">Tools &amp; Guides</Link></li>
              <li><Link to="/about" className="hover:text-[#c6a15b] transition">Our Advantage</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-white mb-5">Contact Us</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#c6a15b] shrink-0 mt-0.5" />
                <a href={`tel:${company.phoneTel}`} className="hover:text-[#c6a15b] transition">{company.phoneDisplay}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#c6a15b] shrink-0 mt-0.5" />
                <a href={`mailto:${company.email}`} className="hover:text-[#c6a15b] transition break-all">{company.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#c6a15b] shrink-0 mt-0.5" />
                <span>{company.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-[#c6a15b] shrink-0 mt-0.5" />
                <span>{company.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} LTR Capital Partners. All rights reserved.</p>
          <p>Equal Housing Lender · This is not a commitment to lend.</p>
        </div>
      </div>
    </footer>
  );
}
